import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const resetPasswordPageK = {
  codeIsNotValid: "reset_password_page.codeIsNotValid",
  emailSent: "reset_password_page.emailSent",
  sendLinkAgain: "reset_password_page.sendLinkAgain",
  weHaveSentLinkToResetPassword: "reset_password_page.weHaveSentLinkToResetPassword",
  enterEmailResetPassword: "reset_password_page.enterEmailResetPassword",
  resetPassword: "reset_password_page.resetPassword",
};

export const useResetPasswordPageT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      codeIsNotValid: t(resetPasswordPageK.codeIsNotValid),
      emailSent: t(resetPasswordPageK.emailSent),
      sendLinkAgain: t(resetPasswordPageK.sendLinkAgain),
      weHaveSentLinkToResetPassword: (email: string) => t(resetPasswordPageK.weHaveSentLinkToResetPassword, { email }),
      enterEmailResetPassword: t(resetPasswordPageK.enterEmailResetPassword),
      resetPassword: t(resetPasswordPageK.resetPassword),
    }),
    [i18n.language]
  );
};